import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getProductSaleInput,
  getProductsSaleInput,
  ProductSaleLiteModel,
  ProductSalesModel,
} from './model';

export function useGetProductsSale(
  input?: getProductsSaleInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ProductSaleLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ProductSaleLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['product-sales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'product-sales',
          params: input?.params,
        }),
      options,
    ),
    ProductSaleLiteModel,
  );
}

export function useGetProductSale(
  input?: getProductSaleInput,
  options?: UseQueryOptions<ApiResult<ProductSalesModel>, ApiError>,
): UseQueryResult<ApiResult<ProductSalesModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['product-sales', input?.id],
      () =>
        QueryFetchFunction({
          url: `product-sales/${input?.id}`,
        }),
      options,
    ),
    ProductSalesModel,
  );
}

export function getProductsSaleKey(input?: getProductsSaleInput) {
  return ['product-sales', input?.params];
}

export function getProductSaleKey(input?: getProductSaleInput) {
  return ['product-sales', input?.id];
}
